import { render, staticRenderFns } from "./cp.vue?vue&type=template&id=718738e2&scoped=true&"
import script from "./cp.vue?vue&type=script&lang=js&"
export * from "./cp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "718738e2",
  null
  
)

export default component.exports